<template>
  <div class="list-page">
    <crumbs title="专利管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="6">
          <enumerate
            url="/api/achievement/getimproductfield"
            v-model="queryCondition.fieldId"
            placeholder="专业领域"
          />
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="申请开始时间"
            end-placeholder="申请结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <region v-model="queryCondition.area" :isAll="true" />
        </el-col>
        <el-col :span="6">
          <enumerate
            url="/api/achievement/getimauditstatus"
            v-model="queryCondition.auditStatus"
            placeholder="审核状态"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-input
            v-model="queryCondition.userName"
            clearable
            placeholder="账号昵称"
          >
          </el-input>
        </el-col>
        <el-col :span="16">
          <el-input
            v-model="queryCondition.keyWords"
            clearable
            placeholder="标题/专利号"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="redirectByPath(`/admin/dataManage/patentInfo/addition`)"
        >添加专利
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="typeName" label="类型" width="90" align="center">
        </el-table-column>
        <el-table-column
          prop="applicationNumber"
          label="专利编号"
          width="160"
          align="center"
        >
        </el-table-column>
        <el-table-column label="专利名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <a
              href="javascript:;"
              class="clickable-link"
              @click="handleLook(scope.row)"
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="fieldName" label="专业领域" align="center">
        </el-table-column>
        <el-table-column
          prop="inventor"
          label="发明人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="area"
          label="地区"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="账号昵称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="申请日期" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.applyDate.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.applyDate.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="auditStatusName"
          label="审核状态"
          width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.auditStatus === 0">
              <el-button size="mini" @click="handleAudit(scope.row)"
                >审核</el-button
              >
            </template>
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "patentList",
  data() {
    return {
      //查询条件
      queryCondition: {
        publishDate: [],
        area: [],
        fieldId: "",
        userName: "",
        auditStatus: "",
        keyWords: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWords, userName, pageIndex, pageSize, publishDate, area } =
          this.queryCondition,
        mixin = {
          fieldId: "",
          auditStatus: ""
        },
        [createBegin = "", createEnd = ""] = publishDate || [],
        [provinceCode = "", cityCode = "", districtCode = ""] = area || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWords,
        userName,
        pageIndex,
        pageSize,
        ...mixin,
        createBegin,
        createEnd,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("patent", "getList", this.processParams()).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/dataManage/patentInfo/modification`,
        {
          id
        },
        this.queryCondition
      );
    },
    // 点击审核
    handleAudit(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/dataManage/patentInfo/audit`,
        {
          id
        },
        this.queryCondition
      );
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("patent", "batchDelete", { patentID: idList }).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
